import React from "react";
import { ReCaptchaProvider } from "@wss/re-captcha";
import { Image } from "@wss/image";
import EmailSignup from "./EmailSignup/EmailSignup";
const NewItemsHeader = () => {
  return <ReCaptchaProvider data-sentry-element="ReCaptchaProvider" data-sentry-component="NewItemsHeader" data-sentry-source-file="NewItemsHeader.tsx">
      <div data-component="newitems-hero" className="lt:-mt-2" style={{
      // eslint-disable-next-line prettier/prettier
      backgroundImage: "url('//cdnimg.webstaurantstore.com/uploads/images/2021/5/newitemsheader.jpg')"
    }}>
        <div className="container">
          <div className="flex flex-col items-center justify-between py-3 sm:flex-row sm:py-8">
            <Image className="mt-6 w-4/5 sm:hidden" src="//cdnimg.webstaurantstore.com/uploads/images/2021/5/newitems.svg" alt="New Items" aria-hidden="true" width="428" height="62" data-sentry-element="Image" data-sentry-source-file="NewItemsHeader.tsx" />
            <Image className="hidden mr-4 mb-4 sm:block md:mb-0" src="//cdnimg.webstaurantstore.com/uploads/images/2021/5/newitems.svg" alt="New Items" aria-hidden="true" width="341" height="170" data-sentry-element="Image" data-sentry-source-file="NewItemsHeader.tsx" />
            <EmailSignup data-sentry-element="EmailSignup" data-sentry-source-file="NewItemsHeader.tsx" />
          </div>
        </div>
      </div>
    </ReCaptchaProvider>;
};
export default NewItemsHeader;